import React from 'react';
import EventLogSection from '../../../components/EventLogSection/EventLogSection';

const PracticeInlineEventLogs = ({
  moduleId,
  practiceId,
  targetUserId = 'all',
  patientId = null,
  sectionFilter = null,
}) => {
  if (!moduleId) return null;

  return (
    <div className="practice-inline-event-logs">
      <div className="event-logs-content">
        <EventLogSection
          moduleId={moduleId}
          targetUserId={targetUserId}
          practiceId={practiceId}
          patientId={patientId}
          sectionFilter={sectionFilter}
        />
      </div>
    </div>
  );
};

export default PracticeInlineEventLogs;
